<template>
  <p
    class="popup">
    {{ error }}
  </p>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';

.popup {
  position: relative;
  display: inline-block;
  padding: 7px 10px;
  background: $color-strawberry;
  color: $color-white;
  font-size: $size-s;

  &::before {
    position: absolute;
    top: 100%;
    left: 50%;
    border: 6px solid transparent;
    border-top: 6px solid $color-strawberry;
    content: '';
    transform: translateX(-50%);
  }
}
</style>
